import React, { Component, createRef } from "react";

import { COMPANY_NAME, dateString, APP_URL, AGENT_SERVER_URL, APP_LIVE_URL, API_URL, THEME_TEXT_COLOR, THEME_COLOR, columnsServices } from "../../../config/config";
import axios from "axios";
import { connect } from "react-redux";

import { addSettings } from "../../../actions";

import $ from "jquery";

import {
  getIntegration,
  getCustomSettings,
} from "./../../../config/reseller_api_calls";

import DataTable from "../../../components/Tables/DataTableReports";
import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import { Link } from "react-router-dom";
import { FormLoader } from "../../../components/ContentLoaders/newLoaders/Form";
import { TableLoader } from "../../../components/ContentLoaders/newLoaders/TableLoader";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "./../../../config/helperClass";
import Tooltip from "@material-ui/core/Tooltip";
import RichTextEditorComponent from "../../../components/Reseller/RichTextEditorComponent";
import dateFormat, { masks } from "dateformat";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";

import HomeIcon from "@material-ui/icons/Home";
import TextField from "../../../components/InputFields/TextField";
import MutextField from "@material-ui/core/TextField";
import * as XLSX from "xlsx";
import moment from "moment";
import DateFnsUtils from "@date-io/date-fns"; // choose your lib
import {
  DatePicker,
  DateTimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateRangePicker from "react-daterange-picker";
import "react-daterange-picker/dist/css/react-calendar.css";
import { extendMoment } from "moment-range";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";

import GooglePlacesAutocomplete from "react-google-places-autocomplete";

import { PhoneInput } from "react-international-phone";
import { PhoneNumberUtil } from "google-libphonenumber";
import { ValidateEmail } from "../../../config/utility";

const extendedMoment = extendMoment(moment);

const animatedComponents = makeAnimated();

const auth = new HelperClass();

class AddSubpoenaReport extends Component {
  constructor() {
    var date = (date = new Date()),
      y = date.getFullYear(),
      m = date.getMonth();

    var datestring = new Date().toISOString().slice(0, 10);

    super();
    this.decimalPoint = Number(auth.getDecimalPoint());
    this.billing_decimalPoint = Number(auth.getBillingDecimalPoint());
    const today = extendedMoment();
    const monthAgo = moment().subtract(7, "day");
    this.state = {
      tableData: [],
      tableLoader: true,
      //start_date: monthAgo.format("YYYY-MM-DD"),
      //end_date: today.format("YYYY-MM-DD"),
      disabled: false,
      errorMessage: "",
      errorMessageTitle: "",
      successMessage: "",
      docErrorMessage: "",
      title: "",
      subpoena_ren_no: "",
      start_date: monthAgo.format("MM-DD-yyyy"),
      end_date: today.format("MM-DD-yyyy"),
      value: moment.range(monthAgo, today),
      description: "",
      report_params: "",
      report_url_id: "",
      add_picture: "",
      report_id: "",
      publish_report: "No",
      added_file: [],
      isEditorReady: false,
      add_pictures: [],
      add_picture_names: [],
      tags: [],
      inputValue: "",

      emailCcs: [],
      inputValueCc: "",
      ccErrorMessage: "",
      subscriber_settings: false,
      billing_settings: false,
      other_did_settings: false,
      contract_settings: false,
      communication_settings: false,
      payment_settings: false,
      didErrorMessage: "",
      enableDids: "dids",
      maxChars: 1000,

      subpoenaOptions: [
        {
          name: "Full Subscriber Name",
          value: "Full Subscriber Name",
          checked: false,
        },
        {
          name: "Billing and service address",
          value: "Billing and service address",
          checked: false,
        },
        {
          name: "Email address(es) associated with account",
          value: "Email address(es) associated with account",
          checked: false,
        },
        {
          name: "Account creation date and termination date (if applicable)",
          value: "Account creation date and termination date (if applicable)",
          checked: false,
        },
        { name: "Account number", value: "Account number", checked: false },
        {
          name: "IP address logs (registration and logins)",
          value: "IP address logs (registration and logins)",
          checked: false,
        },
        {
          name: "Call/SMS metadata logs",
          value: "Call/SMS metadata logs",
          checked: false,
        },
        {
          name: "Device identifiers, if available (IMEI, MAC, etc.)",
          value: "Device identifiers, if available (IMEI, MAC, etc.)",
          checked: false,
        },
        {
          name: "Payment information or method on file (if applicable)",
          value: "Payment information or method on file (if applicable)",
          checked: false,
        },
      ],
      newName: "",
      newValue: "",
      optionsSelected: [],
      optionsContainer: false,

      step: 1,
      address_autocomplete: true,
      useGooglePlaces: true,
      address_validation: true,
      notifyCheckBox: false,
      requester_address: "",
      requester_phone: "",
      requester_name: "",
      requester_type: "Federal Agency",
      office_devision: "",
      requester_contact_name: "",
      requester_contact_title: "",
      requester_email: "",
      legal_authority_cited: "Federal",
      request_type: "Subpoena",
      request_type_other: "",
      dueDate: new Date(new Date().setDate(new Date().getDate() + 1)),
    };
    this.phoneInputRef = createRef();
  }

  serviceSigning = async (value, tableMeta) => {
    // console.log("tableMeta.rowData: ", tableMeta.rowData[6]);
  };

  async componentDidMount() {
    this.setState({
      tableLoader: false,
      tableLoaderListing: false,
      isEditorReady: true,
    });
    this.getCustomSettings();
  }

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  format_date = (value) => {
    let date = value;
    if (date && date !== "") {
      return dateFormat(date, "mm-dd-yyyy");
    } else {
      return "---";
    }
  };

  handleChangeTag = (event) => {
    const { value } = event.target;
    // Allow only numbers
    if (/^\d*$/.test(value)) {
      this.setState({ inputValue: value, didErrorMessage: "" });
    }
  };

  handleChangeTagCc = (event) => {
    const { value } = event.target;
    this.setState({ inputValueCc: value, ccErrorMessage: "" });
  };

  handlePaste = (event) => {
    event.preventDefault();
    const pastedText = event.clipboardData.getData("text");
    this.setState({ inputValue: pastedText }, this.addNumbers);
  };

  handlePasteCc = (event) => {
    event.preventDefault();
    const pastedText = event.clipboardData.getData("text");
    this.setState({ inputValueCc: pastedText }, this.addCcEmails);
  };

  handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === ",") {
      event.preventDefault();

      this.addNumbers();
    }
  };

  handleKeyDownCc = (event) => {
    if (event.key === "Enter" || event.key === ",") {
      event.preventDefault();

      this.addCcEmails();
    }
  };

  addNumbers = () => {
    const { inputValue, tags } = this.state;
    if (!inputValue.trim()) return;

    // Split input by commas and remove extra spaces
    let newNumbers = inputValue
      .split(",") // Split by comma
      .map((num) => num.trim()) // Remove extra spaces
      .filter((num) => num); // Remove empty values

    // Keep only numeric values
    newNumbers = newNumbers.filter((num) => /^\d+$/.test(num));

    // Ensure each number is exactly 10 digits
    const invalidNumbers = newNumbers.filter((num) => num.length !== 10);
    if (invalidNumbers.length > 0) {
      this.setState({
        didErrorMessage: "All numbers must be exactly 10 digits!",
      });
      return;
    }

    // Remove duplicates (both within new input and existing tags)
    newNumbers = [...new Set(newNumbers)].filter((num) => !tags.includes(num));

    // Check maximum limit (100 numbers)
    if (tags.length + newNumbers.length > 100) {
      this.setState({ didErrorMessage: "Maximum 100 numbers allowed!" });
      return;
    }

    this.setState((prevState) => ({
      tags: [...prevState.tags, ...newNumbers],
      inputValue: "",
      didErrorMessage: "",
    }));
  };

  addCcEmails = () => {
    const { inputValueCc, emailCcs } = this.state;
    if (!inputValueCc.trim()) return;

    // Split input by commas and remove extra spaces
    let newEmails = inputValueCc
      .split(",")
      .map((email) => email.trim())
      .filter((email) => email);

    // Keep only valid emails
    newEmails = newEmails.filter((email) => this.validateEmails(email));

    if (newEmails.length === 0) {
      this.setState({ ccErrorMessage: "Please enter valid email(s)." });
      return;
    }

    // Remove duplicates (within input + already existing)
    newEmails = [...new Set(newEmails)].filter(
      (email) => !emailCcs.includes(email)
    );

    // Check maximum 5
    if (emailCcs.length + newEmails.length > 5) {
      this.setState({ ccErrorMessage: "Maximum 5 emails allowed!" });
      return;
    }

    this.setState((prevState) => ({
      emailCcs: [...prevState.emailCcs, ...newEmails],
      inputValueCc: "",
      ccErrorMessage: "",
    }));
  };
  validateEmails = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  handleRemoveTag = (index) => {
    this.setState((prevState) => ({
      tags: prevState.tags.filter((_, i) => i !== index),
    }));
  };

  handleRemoveTagCc = (index) => {
    this.setState((prevState) => ({
      emailCcs: prevState.emailCcs.filter((_, i) => i !== index),
    }));
  };

  onSelect = (value) => {
    this.setState({
      value,
      start_date: value.start.format("MM-DD-yyyy"),
      end_date: value.end.format("MM-DD-yyyy"),
      isOpen: false,
    });
  };

  onToggle = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  checkNumber = async (evt) => {
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    var keyCode = key;
    key = String.fromCharCode(key);
    if (key.length == 0) return;
    var regex = /^[0-9.\b]+$/;
    if (keyCode == 188 || keyCode == 190) {
      return;
    } else {
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    }
  };

  handleChangeTextarea = (event) => {
    const input = event.target.value;

    // Limit to 1000 characters
    if (input.length <= 1000) {
      this.setState({ description: input });
    }
  };

  handleChanges = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
    });
  };

  handleChange = (input) => (e) => {
    this.setState({ [input]: e.target.value });
  };

  handleChangePhone = async (event) => {
    const { target } = event;
    let value = target.type === "radio" ? target.checked : target.value;
    const { name } = target;

    //console.log(name);
    this.setState({
      [name]: value,
    });
  };

  handleEditorChange = (updatedContent) => {
    //console.log('updatedContent: ',updatedContent);
    this.setState({ description: updatedContent });
  };

  handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files); // Convert FileList to an array

    if (!selectedFiles.length) return; // No files selected

    // File type validation
    const allowedFileTypes = [".txt", ".pdf", ".csv", ".xlsx", ".xls", ".zip"];
    const invalidFiles = selectedFiles.filter(
      (file) =>
        !allowedFileTypes.includes(
          `.${file.name.split(".").pop().toLowerCase()}`
        )
    );

    if (invalidFiles.length > 0) {
      this.setState({
        docErrorMessage:
          "Invalid file type detected. Please select valid files.",
      });
      return;
    }

    // File size validation (50MB max per file)
    const maxSizeBytes = 50 * 1024 * 1024;
    const oversizedFiles = selectedFiles.filter(
      (file) => file.size > maxSizeBytes
    );

    if (oversizedFiles.length > 0) {
      this.setState({
        docErrorMessage:
          "Some files exceed the 50MB limit. Choose smaller files.",
      });
      return;
    }

    // Debugging output to ensure files are being processed correctly
    // console.log("Selected Files: ", selectedFiles);
    // console.log("Current add_pictures in state: ", this.state.add_pictures);

    // Append new files to existing array
    this.setState((prevState) => {
      const updatedPictures = [...prevState.add_pictures, ...selectedFiles];
      // console.log("Updated Pictures: ", updatedPictures);
      // **Limit total files to 5**
      if (updatedPictures.length > 1) {
        return {
          docErrorMessage: "You can upload only 1 file.",
        };
      }
      return {
        add_pictures: updatedPictures,
        docErrorMessage: "", // Clear error message
        add_picture_names: updatedPictures.map((file) => file.name),
      };
    });
  };

  handleChangeRef = (event) => {
    const { value } = event.target;

    // Validation: Only allow a-z, A-Z, 0-9, -, _, #, $
    const regex = /^[a-zA-Z0-9\-_#$,]*$/;

    if (!regex.test(value)) {
      this.setState({
        errorMessage:
          "Only letters, numbers, '#', '$', ',', '-' and '_' are allowed.",
      });
      return;
    }

    // Validation: Maximum 25 characters
    if (value.length > 25) {
      this.setState({ errorMessage: "Maximum 25 characters allowed!" });
      return;
    }

    // Update state if valid
    this.setState({ subpoena_ren_no: value, errorMessage: "" });
  };

  fieldValidationUsername = () => {
    let {
      title,
      description,
      subpoena_ren_no,
      tags,
      enableDids,
      optionsSelected,
      requester_address,
      requester_phone,
      requester_name,
      requester_type,
      office_devision,
      requester_contact_name,
      requester_contact_title,
      requester_email,
      legal_authority_cited,
      request_type,
      request_type_other
    } = this.state;

    if (requester_name === "") {
      this.setState({
        errorMessageTitle: "Missing Field",
        errorMessage: "Requester Name / Agency is required.",
        disabled: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else if (office_devision === "") {
      this.setState({
        errorMessageTitle: "Missing Field",
        errorMessage: "Office / Division is required.",
        disabled: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else if (requester_contact_name === "") {
      this.setState({
        errorMessageTitle: "Missing Field",
        errorMessage: "Contact person name is required.",
        disabled: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else if (requester_address === "") {
      this.setState({
        errorMessageTitle: "Missing Field",
        errorMessage: "Complete address is required.",
        disabled: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else if (requester_phone === "") {
      this.setState({
        errorMessageTitle: "Missing Field",
        errorMessage: "Phone number is required.",
        disabled: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else if (!this.isPhoneValid(requester_phone)) {
      this.setState({
        errorMessageTitle: "Invalid Phone",
        errorMessage: "Invalid phone format.",
        disabled: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else if (requester_email === "") {
      this.setState({
        errorMessageTitle: "Missing Field",
        errorMessage: "Email address is required.",
        disabled: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else if (ValidateEmail(requester_email) === false) {
      this.setState({
        errorMessageTitle: "Invalid Email",
        errorMessage: "Please enter valid email address.",
        disabled: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else if (request_type !== "" && request_type === "Other") {
      if (request_type_other === "") {
        this.setState({
          errorMessageTitle: "Missing Other Type",
          errorMessage: "Please specify the `Other` type of request.",
          disabled: false,
        });
        document
          .getElementById("Support_Block")
          ?.scrollIntoView({ top: 0, behavior: "smooth" });
        return false;
      }
    } else if (title === "") {
      this.setState({
        errorMessageTitle: "Missing Field",
        errorMessage: "Title is required.",
        disabled: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else if (subpoena_ren_no === "") {
      this.setState({
        errorMessageTitle: "Missing Field",
        errorMessage: "Reference # is required.",
        disabled: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else if (optionsSelected.length === 0) {
      this.setState({
        errorMessageTitle: "Missing Field",
        errorMessage: "Please choose at least one option.",
        disabled: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } /*else if (enableDids === "dids") {
      if (!tags || tags.length === 0) {
        this.setState({
          errorMessageTitle: "Missing Field",
          errorMessage: "DID(s) are required.",
          disabled: false,
        });
        document
          .getElementById("Support_Block")
          ?.scrollIntoView({ top: 0, behavior: "smooth" });
        return false;
      }
    }*/ else if (description === "") {
      this.setState({
        errorMessageTitle: "Missing Field",
        errorMessage: "Description is required.",
        disabled: false,
      });
      document
        .getElementById("Support_Block")
        ?.scrollIntoView({ top: 0, behavior: "smooth" });
      return false;
    } else {
      this.setState({
        errorMessageTitle: "",
        errorMessage: "",
        disabled: true,
      });
    }

    return true;
  };

  submitRequest = async (e) => {
    e.preventDefault();
    let {
      title,
      description,
      start_date,
      end_date,
      add_picture,
      add_picture_name,
      report_id,
      added_file,
      add_pictures,
      report_params,
      report_url_id,
      publish_report,
      tags,
      subscriber_settings,
      billing_settings,
      other_did_settings,
      contract_settings,
      communication_settings,
      payment_settings,
      subpoena_ren_no,
      enableDids,
      optionsSelected,
      emailCcs,
      requester_address,
      requester_phone,
      requester_name,
      requester_type,
      office_devision,
      requester_contact_name,
      requester_contact_title,
      requester_email,
      legal_authority_cited,
      request_type,
      dueDate,
      request_type_other
    } = this.state;

    this.setState({
      verifyPasswordButton: true,
      disabled: true,
      errorMessageTitle: "",
      errorMessage: "",
    });
    if (this.fieldValidationUsername() === true) {
      const formData = new FormData();
      formData.append("token", process.env.REACT_APP_API_TOKEN);
      formData.append("api_accountno", process.env.REACT_APP_API_ACCOUNTNO);
      formData.append("accountno", auth.getAccount());
      formData.append("report_params", report_params);
      formData.append("report_url_id", report_url_id);
      formData.append("title", title);
      formData.append("description", description);
      formData.append("start_date", start_date);
      formData.append("end_date", end_date);
      formData.append("report_id", report_id);
      formData.append("publish_report", publish_report);
      formData.append("subpoena_ren_no", subpoena_ren_no);
      formData.append("enableDids", enableDids);
      formData.append("dids", JSON.stringify(tags));
      formData.append("user_type", auth.getUserType());
      formData.append("sub_accountno", auth.getSubUserAccount());
      formData.append("is_supoena_user", auth.getSubpoenaType());
      formData.append("requested_options", JSON.stringify(optionsSelected));
      formData.append("email_cc", JSON.stringify(emailCcs));
      //Requester Information
      formData.append("requester_address", requester_address);
      formData.append("requester_phone", requester_phone);
      formData.append("requester_name", requester_name);
      formData.append("requester_type", requester_type);
      formData.append("request_type_other", request_type_other);
      formData.append("office_devision", office_devision);
      formData.append("requester_contact_name", requester_contact_name);
      formData.append("requester_contact_title", requester_contact_title);
      formData.append("requester_email", requester_email);
      formData.append("legal_authority_cited", legal_authority_cited);
      formData.append("request_type", request_type);
      formData.append("dueDate", dueDate);

      formData.append(
        "notifyCheckBox",
        this.state.notifyCheckBox ? "true" : "false"
      );

      //formData.append("added_file", JSON.stringify(added_file));
      add_pictures.forEach((file) => {
        formData.append("files", file);
      });
      console.log("notifyCheckBox: ", this.state.notifyCheckBox.toString());
      try {
        axios
          .post(
           process.env.REACT_APP_API_URL + "subpoena/add_subpoena_report_request",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Credentials": true,
              },
            },
            {}
          )
          .then((response) => {
            console.log("response: ", response.data);
            if (
              response.data.status === 404 &&
              response.data.message === "no_record"
            ) {
              this.setState({
                errorMessageTitle: "Missing Client",
                errorMessage: "Client does not found.",
                disabled: false,
                submitRfq_button_loader: false,
                successMessage: "",
              });
              document
                .getElementById("Support_Block")
                ?.scrollIntoView({ top: 0, behavior: "smooth" });
              setTimeout(() => {
                this.setState({
                  errorMessage: "",
                });
              }, 4000);
            } else if (response.data.status === 403) {
              this.setState({
                errorMessage: response.data.message,
                disabled: false,
                submitRfq_button_loader: false,
                successMessage: "",
              });
              document
                .getElementById("Support_Block")
                ?.scrollIntoView({ top: 0, behavior: "smooth" });
              setTimeout(() => {
                this.setState({
                  errorMessage: "",
                });
              }, 4000);
            } else if (
              response.data.status === 200 &&
              response.data.message === "success"
            ) {
              this.setState({
                successMessage: "Your request has been added successfully.",
                errorMessage: "",
                final_login_url: response.data.login_url,
                showLoginButton: true,
              });
              document
                .getElementById("Support_Block")
                ?.scrollIntoView({ top: 0, behavior: "smooth" });
              setTimeout(() => {
                window.location.replace("/Compliance");
              }, 3000);

              //this.nextStep();
            } else {
              this.setState({
                errorMessageTitle: "System Error",
                errorMessage: "There is some error while adding the request.",
                disabled: false,
                successMessage: "",
                submitRfq_button_loader: false,
              });
              document
                .getElementById("Support_Block")
                ?.scrollIntoView({ top: 0, behavior: "smooth" });
              setTimeout(() => {
                this.setState({
                  errorMessage: "",
                });
              }, 4000);
            }
            this.setState({
              submitRfq_button_loader: false,
            });
          });
      } catch (error) {
        this.setState({
          errorMessageTitle: "System Error",
          errorMessage: "There is some error while updated the request.",
          disabled: false,
          successMessage: "",
          submitRfq_button_loader: false,
        });
        document
          .getElementById("Support_Block")
          ?.scrollIntoView({ top: 0, behavior: "smooth" });
        setTimeout(() => {
          this.setState({
            errorMessage: "",
          });
        }, 4000);
      }
    } else {
      setTimeout(() => {
        this.setState({ errorMessageTitle: "", errorMessage: "" });
      }, 4000);
    }
  };

  handleRemoveFile = (index) => {
    this.setState((prevState) => {
      const updatedPictures = [...prevState.add_pictures];
      const updatedNames = [...prevState.add_picture_names];

      // Remove file from both arrays by index
      updatedPictures.splice(index, 1);
      updatedNames.splice(index, 1);

      return {
        add_pictures: updatedPictures,
        add_picture_names: updatedNames,
      };
    });
  };

  handleRemoveAddedFile = (index) => {
    // console.log("handleRemoveAddedFile: ", this.state.added_file);
    this.setState((prevState) => {
      const updatedNames = [...prevState.added_file];

      // Remove file from both arrays by index

      updatedNames.splice(index, 1);
      // console.log("handleRemoveAddedFileAfter: ", updatedNames);
      return {
        added_file: updatedNames,
      };
    });
  };

  handleOptionChange = (event) => {
    const value = event.target.value;
    this.setState({
      enableDids: event.target.value,
    });
  };

  downloadPdfRfq = async (d_f_name) => {
    var url = d_f_name;
    //let file_name = this.extractFileNameFromUrl(d_f_name);
    url = APP_LIVE_URL + "files_data/kyc_signup/" + d_f_name;
    //console.log("downloadPdfRfq: ", url);
    fetch(url)
      .then((x) => x.blob())
      .then((b) => {
        // console.log("B INSTANCE", b instanceof Blob);
        const url = window.URL.createObjectURL(b);
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = url;
        a.download = d_f_name;
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        this.setState({
          errorMessage: "There is some error while downloading the attachment.",
        });
        setTimeout(() => {
          this.setState({ errorMessage: "" });
        }, 4000);
        // Handle any errors that occurred during the fetch
        console.error("Fetch error:", error);
      });
  };

  handleCheckboxChange = (index) => {
    const options = [...this.state.subpoenaOptions];
    options[index].checked = !options[index].checked;

    const selected = options
      .filter((opt) => opt.checked)
      .map(({ name, value }) => ({ name, value }));

    this.setState({ subpoenaOptions: options, optionsSelected: selected });
  };

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleAddOption = () => {
    const { newName, newValue, subpoenaOptions } = this.state;
    console.log("newName: ", newName);
    if (newName.trim()) {
      const newOption = { name: newName, value: newName, checked: false };
      this.setState({
        subpoenaOptions: [...subpoenaOptions, newOption], // appended to array
        newName: "",
        newValue: "",
      });
    }
  };

  handleDeleteOption = (index) => {
    const options = this.state.subpoenaOptions.filter((_, i) => i !== index);
    const selected = options
      .filter((opt) => opt.checked)
      .map(({ name, value }) => ({ name, value }));

    this.setState({ subpoenaOptions: options, optionsSelected: selected });
  };

  nextStep = () => {
    this.setState({ step: this.state.step + 1 });
  };

  prevStep = () => {
    this.setState({ step: this.state.step - 1 });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", this.state.formData);
    alert("Form submitted successfully!");
  };

  handleAddressSelect = async (place) => {
    const { description } = place.value;
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          description
        )}&key=${process.env.REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY}`
      );
      const data = await response.json();

      if (data.status === "OK") {
        const addressComponents = data.results[0].address_components;
        const formattedAddress = data.results[0].formatted_address;
        let city = null;
        let state = null;
        let country = null;
        let zipCode = null;
        let streetAddress = "";
        let neighborhood = null;
        let locality = null;
        let address2 = "";
        addressComponents.forEach((component) => {
          if (component.types.includes("neighborhood")) {
            neighborhood = component.long_name;
          } else if (component.types.includes("locality")) {
            locality = component.long_name;
          } else if (component.types.includes("administrative_area_level_1")) {
            state = component.short_name;
          } else if (component.types.includes("country")) {
            country = component.long_name;
          } else if (component.types.includes("postal_code")) {
            zipCode = component.long_name;
          } else if (component.types.includes("subpremise")) {
            address2 = component.long_name;
          } else if (
            ![
              "neighborhood",
              "sublocality",
              "sublocality_level_1",
              "sublocality_level_2",
              "administrative_area_level_2",
              "administrative_area_level_3",
              "postal_code_suffix",
            ].includes(component.types[0])
          ) {
            if (streetAddress !== "") {
              streetAddress += " ";
            }
            streetAddress += component.long_name;
          }
        });
        // Check if neighborhood is part of the formatted address
        if (neighborhood && formattedAddress.includes(neighborhood)) {
          city = neighborhood;
        } else {
          city = locality;
        }
        this.setState({
          /*client_city: city && city !== "" ? city : "",
          client_state: state && state !== "" ? state : "",
          client_zip: zipCode && zipCode !== "" ? zipCode : "",
          client_country: country && country !== "" ? country : "",
          client_address:
            streetAddress && streetAddress !== "" ? streetAddress : "",
          client_address2: address2 && address2 !== "" ? address2 : "",*/
          requester_address: formattedAddress,
        });
      } else {
        console.error("Reverse geocoding request failed:", data.status);
      }
    } catch (error) {
      console.error("Error fetching reverse geocoding data:", error);
    }
  };

  getCustomSettings = async () => {
    try {
      const getCustomSetting_res = await getCustomSettings(
        auth.getAccount(),
        auth.getToken()
      );
      //console.log("getCustomSetting_res: ", getCustomSetting_res.data);
      if (
        getCustomSetting_res.data.status === 200 &&
        getCustomSetting_res.data.data &&
        getCustomSetting_res.data.data.length > 0
      ) {
        this.setState({
          address_autocomplete:
            getCustomSetting_res.data.data[0].address_autocomplete || "Yes",
          address_validation:
            getCustomSetting_res.data.data[0].address_validation || "Yes",
        });
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };

  phoneUtil = PhoneNumberUtil.getInstance();

  isPhoneValid = (phone) => {
    try {
      return this.phoneUtil.isValidNumber(
        this.phoneUtil.parseAndKeepRawInput(phone)
      );
    } catch (error) {
      return false;
    }
  };

  handleFocus = () => {
    // Move cursor to the end of the input value
    const input = this.phoneInputRef.current;
    if (input) {
      const value = input.value;
      input.setSelectionRange(value.length, value.length);
    }
  };

  handleDateChange = (newDate) => {
    const { issueDate } = this.state;

    if (issueDate && newDate < new Date(issueDate)) {
      this.setState({
        errorMessageInfo: "Due date cannot be earlier than Issue date.",
      });
    } else {
      this.setState({
        dueDate: newDate,
        errorMessageInfo: "", // clear error if valid
      });
    }
  };

  render() {
    //  let tableTitle = this.props.props.match.params.api_url.replaceAll("_", " ");
    const Theme = {
      palette: {
        primary: {
          contrastText: "#FFFFFF",
          dark: "#000000",
          main: "#000000",
          light: "#000000",
        },
      },
    };
    const {
      isOpen,
      value,
      start_date,
      end_date,
      tags,
      inputValue,
      description,
      maxChars,
      inputValueCc,
      useGooglePlaces,
    } = this.state;
    const formattedDateRange = start_date ? `${start_date} - ${end_date}` : "";
    const options = {
      selectableRows: "multiple", // Enable checkboxes for row selection
    };

    const remaining = maxChars - description.length;
    const styles = {
      container: {
        width: "100%",
        maxWidth: "100%",
      },
      inputWrapper: {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        border: "1px solid #ccc",
        padding: "5px",
        borderRadius: "5px",
        minHeight: "40px",
      },
      tag: {
        display: "flex",
        alignItems: "center",
        backgroundColor: "#ebeef2",
        color: "#526484",
        padding: "0 .5rem",
        borderRadius: "3px",
        margin: "0.1875rem 0.1875rem",
        fontSize: "13px",
        lineHeight: "1.5rem",
        fontWeight: "bold",
      },
      removeButton: {
        marginLeft: "8px",
        border: "none",
        background: "none",
        color: "#526484",
        fontWeight: "bold",
        cursor: "pointer",
      },
      input: {
        border: "none",
        outline: "none",
        padding: "5px",
        fontSize: "14px",
        flexGrow: 1,
        minWidth: "50px",
      },
    };
    return (
      <div className="nk-content " id="Support_Block">
        <div className="container-fluid">
          {this.props.defaultSettings === "missing" ? <SettingsError /> : null}
          {/* MSA WARNING  START*/}
          {this.props.is_msa_signed === "No" ? <MsaWarning /> : null}

          {/* MSA WARNING END */}

          <div className="nk-content-inner">
            <div className="nk-content-body">
              {/* PAGE TITLE START */}
              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                  <div className="nk-block-head-content">
                    <Breadcrumbs aria-label="breadcrumb">
                      {auth.getSubpoenaType() !== "Yes" ? (
                        <Link
                          color="inherit"
                          onClick={() => this.addMenuHistory("/")}
                          className=""
                          style={{
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                          }}
                        >
                          <HomeIcon fontSize="inherit" className="" />
                          Home
                        </Link>
                      ) : null}

                      <Link
                        color="inherit"
                        onClick={() => this.addMenuHistory("/Compliance")}
                        className=""
                        style={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        {auth.getSubpoenaType() === "Yes" ? (
                          <HomeIcon fontSize="inherit" className="" />
                        ) : null}
                        Subpoena Requests
                      </Link>
                      <Typography color="textPrimary" className="">
                        Add Request
                      </Typography>
                    </Breadcrumbs>
                  </div>
                </div>
              </div>

              {/* PAGE TITLE END */}
              <div className="nk-block">
                <div className="row g-4">
                  {/* Table 5th Col Start */}
                  <div className="col-xxl-12">
                    <div className="nk-block nk-block-lg">
                      <div className="card card-bordered">
                        <div className="card-inner">
                          {this.state.errorMessage !== "" ? (
                            <div
                              className="example-alert example-alert-revoke mt-3 mb-3"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.errorMessage}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {this.state.successMessage !== "" ? (
                            <div
                              className="example-alert example-alert-revoke mt-3 mb-3"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-success">
                                <div className="alert-text">
                                  <h4>Success</h4>
                                  <p>{this.state.successMessage}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {this.state.tableLoader === true ? (
                            TableLoader()
                          ) : (
                            <form
                              method="post"
                              className="pageForm"
                              onSubmit={this.submitRequest}
                            autoComplete="off"
                            role="presentation"
                            >
                              <div className="row g-4">
                                <div className="nk-block">
                                  <div className="card card-bordered">
                                    <div className="nk-kycfm">
                                      <div
                                        className="nk-kycfm-head"
                                        style={{
                                          background: "rgb(245, 246, 250)",
                                        }}
                                      >
                                        <div className="nk-kycfm-count">01</div>
                                        <div className="nk-kycfm-title">
                                          <h5 className="title">
                                            Requester Information
                                          </h5>
                                          <p className="sub-title">
                                            Enter the information about the
                                            requestor.
                                          </p>
                                        </div>
                                      </div>
                                      <div className="nk-kycfm-content">
                                        <div className="row gy-4">
                                          <div className="col-sm-4">
                                            <div className="form-group">
                                              <label
                                                className="form-label"
                                                for="requester_name"
                                              >
                                                Requester Name / Agency <sup>*</sup>
                                              </label>
                                              <div className="form-control-wrap">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  id="requester_name"
                                                  name="requester_name"
                                                  value={this.state.requester_name}
                                                  onChange={this.handleChanges}
                                                  maxLength={100}
                                                  placeholder="e.g., Christian County Prosecuting Attorney’s Office / Federal Bureau of Investigation"
                                                autoComplete="new-password" />
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-sm-4">
                                            <div className="form-group">
                                              <label
                                                className="form-label"
                                                for="requester_type"
                                              >
                                                Requester Type
                                              </label>
                                              <div className="form-control-wrap ">
                                                <div className="form-control-select">
                                                  <select
                                                    className="form-control"
                                                    id="requester_type"
                                                    name="requester_type"
                                                    value={this.state.requester_type}
                                                    onChange={this.handleChanges}

                                                  >
                                                    <option value="Federal Agency" key="rt-1">
                                                      Federal Agency
                                                    </option>
                                                    <option value="State Agency" key="rt-2">
                                                      State Agency
                                                    </option>
                                                    <option value="Local Agency" key="rt-3">
                                                      Local Agency
                                                    </option>
                                                  </select>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-sm-4">
                                            <div className="form-group">
                                              <label
                                                className="form-label"
                                                for="office_devision"
                                              >
                                                Office / Division <sup>*</sup>
                                              </label>
                                              <div className="form-control-wrap">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  id="office_devision"
                                                  name="office_devision"
                                                  value={this.state.office_devision}
                                                  onChange={this.handleChanges}
                                                  maxLength={64}
                                                  placeholder="e.g., Criminal Division, Cybercrime Unit"
                                                autoComplete="new-password" />
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-lg-12">
                                            <p style={{ fontWeight: "bold" }}>
                                              Requester Contact Person(s)
                                            </p>
                                          </div>
                                          <div className="col-sm-6">
                                            <div className="form-group">
                                              <label
                                                className="form-label"
                                                for="requester_contact_name"
                                              >
                                                Contact Person name <sup>*</sup>
                                              </label>
                                              <div className="form-control-wrap">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  id="requester_contact_name"
                                                  name="requester_contact_name"
                                                  value={this.state.requester_contact_name}
                                                  onChange={this.handleChanges}
                                                  maxLength={64}
                                                  placeholder="e.g., John Doe / Kevin Kostner"
                                                autoComplete="new-password" />
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-sm-6">
                                            <div className="form-group">
                                              <label
                                                className="form-label"
                                                for="requester_contact_title"
                                              >
                                                Contact Person Title
                                              </label>
                                              <div className="form-control-wrap">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  id="requester_contact_title"
                                                  name="requester_contact_title"
                                                  value={this.state.requester_contact_title}
                                                  onChange={this.handleChanges}
                                                  maxLength={64}
                                                  placeholder="e.g., Special Agent / Assistant Prosecuting Attorney"
                                                autoComplete="new-password" />
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-sm-6">
                                            <div className="form-group">
                                              <label
                                                className="form-label"
                                                for="requester_address"
                                              >
                                                Address <sup>*</sup>
                                              </label>
                                              <div className="form-control-wrap">
                                                {this.state
                                                  .address_autocomplete ===
                                                  "Yes" ? (
                                                  useGooglePlaces ? (
                                                    <GooglePlacesAutocomplete
                                                      apiKey={
                                                        process.env
                                                          .REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY
                                                      }
                                                      apiOptions={{ loading: 'async' }}
                                                      selectProps={{
                                                        value: this.state
                                                          .requester_address
                                                          ? {
                                                            label:
                                                              this.state
                                                                .requester_address,
                                                            value:
                                                              this.state
                                                                .requester_address,
                                                          }
                                                          : null,
                                                        onChange:
                                                          this
                                                            .handleAddressSelect,
                                                        placeholder: this.state
                                                          .requester_address
                                                          ? null
                                                          : "Enter your address..",
                                                        styles: {
                                                          control: (
                                                            provided
                                                          ) => ({
                                                            ...provided,
                                                            minHeight: "40px",
                                                          }),
                                                        },
                                                      }}
                                                      className="googleLocation-autocomplete"
                                                    />
                                                  ) : (
                                                    <input
                                                      type="text"
                                                      className="form-control "
                                                      id="requester_address"
                                                      name="requester_address"
                                                      value={
                                                        this.state
                                                          .requester_address
                                                      }
                                                      onChange={
                                                        this.handleChange
                                                      }
                                                      placeholder="Enter your address"
                                                      //maxLength={50}
                                                      inputProps={{
                                                        maxLength: 50,
                                                      }}
                                                      fullWidth
                                                      error={
                                                        this.state
                                                          .errorClientAddress ===
                                                        "error"
                                                      }
                                                    autoComplete="new-password" />
                                                  )
                                                ) : (
                                                  // address_autocomplete === "No" → show PO Box only
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    id="requester_address"
                                                    name="requester_address"
                                                    value={
                                                      this.state
                                                        .requester_address
                                                    }
                                                    onChange={this.handleChange}
                                                    placeholder="Enter your address"
                                                    //maxLength={50}
                                                    inputProps={{
                                                      maxLength: 50,
                                                    }}
                                                    fullWidth
                                                    error={
                                                      this.state
                                                        .errorClientAddress ===
                                                      "error"
                                                    }
                                                  autoComplete="new-password" />
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-sm-6">
                                            <div className="form-group">
                                              <label
                                                className="form-label"
                                                for="requester_phone"
                                              >
                                                Phone <sup>*</sup>
                                              </label>
                                              <div className="form-control-wrap">
                                                <PhoneInput
                                                  required
                                                  defaultCountry={"us"}
                                                  inputProps={{
                                                    name: "requester_phone",
                                                    id: "requester_phone",
                                                    maxLength: 20,
                                                  }}
                                                  style={{
                                                    marginTop: "0px",
                                                    height: "40px",
                                                  }}
                                                  value={
                                                    this.state.isLoading
                                                      ? ""
                                                      : this.state
                                                        .requester_phone
                                                  }
                                                  placeholder={
                                                    this.state.isLoading
                                                      ? "Loading..."
                                                      : "Enter the requester phone number"
                                                  }
                                                  onChange={(value) =>
                                                    this.handleChangePhone({
                                                      target: {
                                                        name: "requester_phone",
                                                        value,
                                                      },
                                                    })
                                                  }
                                                  helperText="Enter the requester phone number."
                                                  label="Requester Phone Number"
                                                  ref={this.phoneInputRef}
                                                  onFocus={this.handleFocus}
                                                />
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-sm-6">
                                            <div className="form-group">
                                              <label
                                                className="form-label"
                                                for="requester_email"
                                              >
                                                Email <sup>*</sup>
                                              </label>
                                              <div className="form-control-wrap">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  id="requester_email"
                                                  name="requester_email"
                                                  value={this.state.requester_email}
                                                  onChange={this.handleChanges}
                                                  maxLength={100}
                                                  placeholder="Enter the valid email address"
                                                autoComplete="new-password" />
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-sm-6">
                                            <div className="form-group">
                                              <label
                                                className="form-label"
                                                for="legal_authority_cited"
                                              >
                                                Legal Authority Cited{" "}
                                                <Tooltip
                                                  title="Agency"
                                                  placement="top"
                                                >
                                                  <span className="text-primary">
                                                    <em className="icon ni ni-info"></em>
                                                  </span>
                                                </Tooltip>
                                              </label>
                                              <div className="form-control-wrap ">
                                                <div className="form-control-select">
                                                  <select
                                                    className="form-control"
                                                    id="legal_authority_cited"
                                                    name="legal_authority_cited"
                                                    value={this.state.legal_authority_cited}
                                                    onChange={this.handleChanges}

                                                  >
                                                    <option value="Federal" key="lac-1">
                                                      Federal
                                                    </option>
                                                    <option value="State" key="lac-2">
                                                      State
                                                    </option>
                                                  </select>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-sm-6">
                                            <div className="form-group">
                                              <label
                                                className="form-label"
                                                for="request_type"
                                              >
                                                Type of Request
                                              </label>
                                              <div className="form-control-wrap ">
                                                <div className="form-control-select">
                                                  <select
                                                    className="form-control"
                                                    id="request_type"
                                                    name="request_type"
                                                    value={this.state.request_type}
                                                    onChange={this.handleChanges}
                                                  >
                                                    <option value="Subpoena" key="ret-1">
                                                      Subpoena
                                                    </option>
                                                    <option value="Court Order" key="ret-2">
                                                      Court Order
                                                    </option>
                                                    <option value="Search Warrant" key="ret-3">
                                                      Search Warrant
                                                    </option>
                                                    <option value="Preservation Request" key="ret-4">
                                                      Preservation Request
                                                    </option>
                                                    <option value="Other" key="ret-5">
                                                      Other (Specify)
                                                    </option>
                                                  </select>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          {this.state.request_type === "Other" ? (
                                            <div className="col-sm-6">
                                              <div className="form-group">
                                              <label
                                                className="form-label"
                                                for="requester_email"
                                              >
                                                Specify Other Type <sup>*</sup>
                                              </label>
                                              <div className="form-control-wrap">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  id="request_type_other"
                                                  name="request_type_other"
                                                  value={this.state.request_type_other}
                                                  onChange={this.handleChanges}
                                                  maxLength={100}
                                                  placeholder=""
                                                autoComplete="new-password" />
                                              </div>
                                            </div>
                                            </div>
                                          ) : null}
                                          
                                        </div>
                                      </div>
                                      <div
                                        className="nk-kycfm-head"
                                        title="Click to open the Rate Settings"
                                        style={{
                                          background: "rgb(245, 246, 250)",
                                        }}
                                      >
                                        <div className="nk-kycfm-count">02</div>
                                        <div className="nk-kycfm-title">
                                          <h5 className="title">
                                            Request Information
                                          </h5>
                                          <p className="sub-title">
                                            Enter the request details, including
                                            the title, case reference/docket
                                            number, and the date range for which
                                            the records are being requested.
                                          </p>
                                        </div>
                                      </div>
                                      <div className="nk-kycfm-content">
                                        <div className="row g-4">
                                          <div className="col-lg-6">
                                            <div className="form-group">
                                              <label
                                                className="form-label"
                                                for="title"
                                              >
                                                Title <sup>*</sup>
                                              </label>
                                              <div className="form-control-wrap">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  id="title"
                                                  name="title"
                                                  value={this.state.title}
                                                  onChange={this.handleChanges}
                                                  placeholder=""
                                                  maxLength={100}
                                                autoComplete="new-password" />
                                                <small>
                                                  Enter descriptive title for
                                                  your report request.
                                                </small>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-lg-6">
                                            <div className="form-group">
                                              <label
                                                className="form-label"
                                                for="title"
                                              >
                                                Reference # <sup>*</sup>
                                              </label>
                                              <div className="form-control-wrap">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  id="subpoena_ren_no"
                                                  name="subpoena_ren_no"
                                                  defaultValue={
                                                    this.state.subpoena_ren_no
                                                  }
                                                  onChange={
                                                    this.handleChangeRef
                                                  }
                                                  placeholder=""
                                                  maxLength={25}
                                                autoComplete="new-password" />
                                                <small>
                                                  Enter descriptive ref. number
                                                  for your subpoena request.
                                                  Only numbers, alphabets, - # $
                                                  , and _ is allowed. Maximum 32
                                                  characters are allowed.
                                                </small>
                                              </div>
                                            </div>
                                          </div>

                                          <div className="col-lg-6">
                                            <div className="form-group">
                                              <div
                                                onClick={this.onToggle}
                                                className=""
                                              >
                                                <TextField
                                                  label="Date and Time"
                                                  variant="outlined"
                                                  fullWidth
                                                  value={formattedDateRange}
                                                  InputProps={{
                                                    onClick: this.onToggle,
                                                  }}
                                                  placeholder="Select Date Range"
                                                autoComplete="new-password"
                                                />

                                              </div>
                                            </div>
                                            {isOpen && (
                                              <div
                                                className="fixed inset-0"
                                                style={{
                                                  zIndex: 1000,
                                                  position: "absolute",
                                                  marginTop: "-20px",
                                                }}
                                              >
                                                <div
                                                  className="absolute inset-0"
                                                  onClick={this.onToggle}
                                                ></div>
                                                <div
                                                  className="absolute top-40 left-1/2 -translate-x-1/2 bg-white shadow-lg rounded-lg p-4"
                                                  style={{ zIndex: 1001 }}
                                                >
                                                  <div
                                                    style={{
                                                      position: "absolute",
                                                      top: "10px",
                                                      right: "10px",
                                                      cursor: "pointer",
                                                      zIndex: 1002,
                                                    }}
                                                    onClick={this.onToggle}
                                                  >
                                                    <em className="icon ni ni-cross"></em>
                                                  </div>
                                                  <DateRangePicker
                                                    value={value}
                                                    onSelect={this.onSelect}
                                                    singleDateRange={true}
                                                    numberOfCalendars={2}
                                                    showLegend={true}
                                                  />
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                          <div className="col-xxl-6 col-md-6 col-sm-12">
                                            <div className="form-group">
                                              <label
                                                className="form-label"
                                                for="dueDate"
                                              >
                                                Due Date
                                              </label>
                                              <div className="form-control-wrap">
                                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                  <DatePicker
                                                    variant="dialog"
                                                    name="dueDate"
                                                    id="dueDate"
                                                    inputVariant="outlined"
                                                    format="MM-dd-yyyy"
                                                    fullWidth
                                                    value={this.state.dueDate}
                                                    onChange={this.handleDateChange}
                                                    rientation="landscape"
                                                    InputProps={{
                                                      style: {
                                                        padding: "1px 1px", // adjust as you like
                                                      }
                                                    }}
                                                    size="small"
                                                  />
                                                </MuiPickersUtilsProvider>
                                              </div>
                                              <div className="form-note">Due date of the request</div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        className="nk-kycfm-head"
                                        title="Click to open the Miscellaneous Rates / Cancellation Fee Settings"
                                        style={{
                                          background: "rgb(245, 246, 250)",
                                        }}
                                      >
                                        <div className="nk-kycfm-count">03</div>
                                        <div className="nk-kycfm-title">
                                          <h5 className="title">
                                            DID(s) & Records Sought
                                          </h5>
                                          <p className="sub-title">
                                            Enter DID(s) or upload DID(s) file.
                                            Please select the records sought
                                            from the options below. If the
                                            required option is not available,
                                            you may add a new one by clicking
                                            Add New Option and then the Plus
                                            button. And brief description of why
                                            the appearance, testimony, or
                                            records are being sought.
                                          </p>
                                        </div>
                                      </div>
                                      <div className="nk-kycfm-content">
                                        <div className="row g-4">
                                          <div
                                            className="col-lg-12"
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              marginBottom: "10px",
                                            }}
                                          >
                                            <h6
                                              style={{
                                                margin: 0,
                                                marginRight: "10px",
                                              }}
                                            >
                                              DID(s) <sup></sup>
                                            </h6>
                                          </div>
                                          <div className="col-lg-12">
                                            <div className="form-group">
                                              <ul className="nk-kycfm-control-list g-3">
                                                <li className="nk-kycfm-control-item">
                                                  <input
                                                    className="nk-kycfm-control"
                                                    type="radio" // Use checkbox instead of radio for a toggle switch
                                                    name="enableDids"
                                                    id="enableDids1"
                                                    data-title="Enter DIDs"
                                                    checked={
                                                      this.state.enableDids ===
                                                        "dids"
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={
                                                      this.handleOptionChange
                                                    }
                                                    value="dids"
                                                  autoComplete="new-password" />
                                                  <label
                                                    className="nk-kycfm-label"
                                                    htmlFor="enableDids1"
                                                  >
                                                    <span className="nk-kycfm-label-icon">
                                                      <div className="label-icon fs-22px">
                                                        <em className="icon ni ni-dashboard"></em>
                                                      </div>
                                                    </span>
                                                    <span className="nk-kycfm-label-text">
                                                      Enter DID's
                                                    </span>
                                                  </label>
                                                </li>
                                                <li className="nk-kycfm-control-item">
                                                  <input
                                                    className="nk-kycfm-control"
                                                    type="radio" // Use checkbox instead of radio for a toggle switch
                                                    name="enableDids"
                                                    id="enableDids2"
                                                    data-title="Allow Mutiple Submission"
                                                    checked={
                                                      this.state.enableDids ===
                                                        "csv"
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={
                                                      this.handleOptionChange
                                                    }
                                                    value="csv"
                                                  autoComplete="new-password" />
                                                  <label
                                                    className="nk-kycfm-label"
                                                    htmlFor="enableDids2"
                                                  >
                                                    <span className="nk-kycfm-label-icon">
                                                      <div className="label-icon fs-22px">
                                                        <em className="icon ni ni-repeat-v"></em>
                                                      </div>
                                                    </span>
                                                    <span className="nk-kycfm-label-text">
                                                      Upload File
                                                    </span>
                                                  </label>
                                                </li>
                                              </ul>
                                            </div>
                                          </div>
                                          {this.state.enableDids === "dids" ? (
                                            <div className="col-lg-12">
                                              <div className="form-group">
                                                <label
                                                  className="form-label"
                                                  for="title"
                                                >
                                                  DID(s) <sup></sup>
                                                </label>
                                                <div className="form-control-wrap">
                                                  <div style={styles.container}>
                                                    <div
                                                      style={
                                                        styles.inputWrapper
                                                      }
                                                    >
                                                      {tags.map(
                                                        (tag, index) => (
                                                          <span
                                                            key={index}
                                                            style={styles.tag}
                                                          >
                                                            {tag}
                                                            <button
                                                              type="button"
                                                              style={
                                                                styles.removeButton
                                                              }
                                                              onClick={() =>
                                                                this.handleRemoveTag(
                                                                  index
                                                                )
                                                              }
                                                            >
                                                              &times;
                                                            </button>
                                                          </span>
                                                        )
                                                      )}
                                                      <input
                                                        type="text"
                                                        value={inputValue}
                                                        onChange={
                                                          this.handleChangeTag
                                                        }
                                                        onKeyDown={
                                                          this.handleKeyDown
                                                        }
                                                        onPaste={
                                                          this.handlePaste
                                                        }
                                                        placeholder="Enter or paste 10-digit numbers..."
                                                        style={styles.input}
                                                      autoComplete="new-password" />
                                                    </div>
                                                  </div>
                                                  <small>
                                                    1. Only numbers allowed.
                                                    <br />
                                                    2. Maximum 100 numbers
                                                    allowed.
                                                    <br />
                                                    3. Only 10-digit numbers are
                                                    accepted.
                                                    <br />
                                                    4. No duplicates allowed
                                                    (even across pasted and
                                                    existing values).
                                                    <br />
                                                    5. Press "Enter" or "," to
                                                    add a number manually.
                                                    <br />
                                                    6. Click "X" to remove a
                                                    number.
                                                    <br />
                                                    7. Paste comma-separated
                                                    numbers (with or without
                                                    spaces) (e.g., 1234567890,
                                                    2987654321, 1122334455)
                                                  </small>
                                                </div>
                                              </div>
                                              {this.state.didErrorMessage !==
                                                "" ? (
                                                <div
                                                  className="example-alert example-alert-revoke mt-3 mb-3"
                                                  style={{
                                                    marginBottom: "15px",
                                                  }}
                                                >
                                                  <div className="alert alert-pro alert-danger">
                                                    <div className="alert-text">
                                                      <h4>DID Error</h4>
                                                      <p>
                                                        {
                                                          this.state
                                                            .didErrorMessage
                                                        }
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div>
                                              ) : null}
                                            </div>
                                          ) : this.state.enableDids ===
                                            "csv" ? (
                                            <div className="col-lg-12">
                                              {this.state.docErrorMessage !==
                                                "" ? (
                                                <div className="col-lg-12">
                                                  <div
                                                    className="example-alert example-alert-revoke mt-3 mb-3"
                                                    style={{
                                                      marginBottom: "15px",
                                                    }}
                                                  >
                                                    <div className="alert alert-pro alert-danger">
                                                      <div className="alert-text">
                                                        <h4>Error</h4>
                                                        <p>
                                                          {
                                                            this.state
                                                              .docErrorMessage
                                                          }
                                                        </p>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              ) : null}
                                              <div className="card card-bordered">
                                                <div className="card-inner">
                                                  <div className="col-lg-12">
                                                    <div className="nk-block-head">
                                                      <div className="nk-block-between-md g-4">
                                                        <div className="nk-block-head-content">
                                                          <h5 className="nk-block-title title">
                                                            Upload CSV File{" "}
                                                            <Tooltip
                                                              title="Upload the file of DID's"
                                                              placement="right"
                                                            >
                                                              <em
                                                                className="icon ni ni-info"
                                                                style={{
                                                                  color:
                                                                    "#6576ff",
                                                                }}
                                                              ></em>
                                                            </Tooltip>
                                                          </h5>
                                                        </div>
                                                        <div className="nk-block-head-content">
                                                          <ul className="nk-block-tools gx-3">
                                                            <li className="order-md-last">
                                                              <a
                                                                onClick={() =>
                                                                  this.downloadPdfRfq(
                                                                    "dids.csv"
                                                                  )
                                                                }
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                  marginLeft:
                                                                    "15px",
                                                                }}
                                                              >
                                                                <span className="badge badge-outline-primary">
                                                                  <em className="icon ni ni-download"></em>{" "}
                                                                  Download
                                                                  Sample
                                                                </span>
                                                              </a>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>

                                                  <div className="col-lg-12 mt-2">
                                                    <div className="form-group">
                                                      <div
                                                        className="form-control-group"
                                                        id="fileContainer"
                                                      >
                                                        <input
                                                          type="file"
                                                          id="add_picture"
                                                          className="file-block"
                                                          name="add_picture"
                                                          defaultValue={
                                                            this.state
                                                              .add_picture
                                                          }
                                                          accept=".xlx, .xlxs, .csv"
                                                          onChange={
                                                            this
                                                              .handleFileChange
                                                          }
                                                        autoComplete="new-password" />
                                                      </div>
                                                      <p
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          margin: "5px 0 0 3px",
                                                        }}
                                                      >
                                                        Upload the DID file.
                                                        <br />
                                                        Supported formats
                                                        include: .txt, .pdf,
                                                        .csv, .xlsx, .xls, .zip
                                                      </p>
                                                      <p
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          margin: "2px 0 0 3px",
                                                        }}
                                                      >
                                                        Maximum file size
                                                        allowed: 50MB.
                                                      </p>
                                                      {this.state
                                                        .add_picture_names
                                                        .length > 0 && (
                                                          <ul
                                                            style={{
                                                              marginLeft: "30px",
                                                            }}
                                                          >
                                                            {this.state.add_picture_names.map(
                                                              (name, index) => (
                                                                <li
                                                                  className="text-primary"
                                                                  style={{
                                                                    listStyle:
                                                                      "disc",
                                                                  }}
                                                                  key={index}
                                                                >
                                                                  {name}{" "}
                                                                  <a
                                                                    onClick={() =>
                                                                      this.handleRemoveFile(
                                                                        index
                                                                      )
                                                                    }
                                                                    style={{
                                                                      cursor:
                                                                        "pointer",
                                                                      marginLeft:
                                                                        "10px",
                                                                      fontSize:
                                                                        "16px",
                                                                    }}
                                                                    className="text-danger"
                                                                  >
                                                                    <em className="icon ni ni-trash"></em>
                                                                  </a>
                                                                </li>
                                                              )
                                                            )}
                                                          </ul>
                                                        )}
                                                      {this.state.added_file &&
                                                        this.state.added_file
                                                          .length > 0 ? (
                                                        <>
                                                          {this.state.added_file.map(
                                                            (item, index) => (
                                                              <div key={index}>
                                                                {item.added_file.map(
                                                                  (
                                                                    file,
                                                                    fileIndex
                                                                  ) => (
                                                                    <div
                                                                      className="text-primary"
                                                                      key={
                                                                        fileIndex
                                                                      }
                                                                    >
                                                                      {index +
                                                                        1}
                                                                      . {file}{" "}
                                                                      <a
                                                                        onClick={() =>
                                                                          this.handleRemoveAddedFile(
                                                                            index
                                                                          )
                                                                        }
                                                                        style={{
                                                                          cursor:
                                                                            "pointer",
                                                                          marginLeft:
                                                                            "10px",
                                                                          fontSize:
                                                                            "16px",
                                                                        }}
                                                                        className="text-danger"
                                                                      >
                                                                        <em className="icon ni ni-trash"></em>
                                                                      </a>
                                                                    </div>
                                                                  )
                                                                )}
                                                              </div>
                                                            )
                                                          )}
                                                        </>
                                                      ) : null}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          ) : null}
                                          <div className="col-lg-12">
                                            <label
                                              className="form-label"
                                              for="title"
                                            >
                                              Choose Options <sup>*</sup>
                                            </label>
                                            <p>
                                              Please select the records sought
                                              from the options below. If the
                                              required option is not available,
                                              you may add a new one by clicking
                                              Add New Option and then the Plus
                                              button.
                                            </p>
                                            
                                            <div className="form-pm-group">
                                              <ul className="buysell-pm-list">
                                                {this.state.subpoenaOptions.map(
                                                  (option, index) => (
                                                    <li
                                                      className="buysell-pm-item ourCheckbox"
                                                      key={`options_${index}`}
                                                      style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "space-between",
                                                      }}
                                                    >
                                                      <div>
                                                        <input
                                                          type="checkbox"
                                                          //className="buysell-pm-control"
                                                          className="buysell-pm-control"
                                                          name="subscriber_settings"
                                                          onChange={() =>
                                                            this.handleCheckboxChange(
                                                              index
                                                            )
                                                          }
                                                          id={`sub_options_${index}`}
                                                          checked={
                                                            option.checked
                                                          }
                                                          value="subscriber"
                                                        />
                                                        <label
                                                          className="buysell-pm-label"
                                                          htmlFor={`sub_options_${index}`}
                                                        >
                                                          <span className="pm-name">
                                                            {option.name}
                                                          </span>
                                                        </label>
                                                      </div>
                                                      {/*<Tooltip
                                                        title="Remove Option"
                                                        placement="left"
                                                      >
                                                        <a
                                                          style={{
                                                            cursor: "pointer",
                                                            marginRight: "20px",
                                                            fontSize: "20px",
                                                          }}
                                                          className="text-danger"
                                                          onClick={() =>
                                                            this.handleDeleteOption(
                                                              index
                                                            )
                                                          }
                                                        >
                                                          <em className="icon ni ni-trash"></em>
                                                        </a>
                                                      </Tooltip>*/}
                                                    </li>
                                                  )
                                                )}
                                              </ul>
                                            </div>
                                          </div>
                                          <div className="col-md-12">
                                            <ul className="nk-block-tools gx-3">
                                              <li className="order-md-last">
                                                <a
                                                  onClick={() => {
                                                    this.setState({
                                                      optionsContainer: true,
                                                    });
                                                  }}
                                                  style={{ cursor: "pointer" }}
                                                  className="btn btn-white btn-dim btn-outline-primary"
                                                >
                                                  <span>Add New Option</span>
                                                </a>
                                              </li>
                                            </ul>
                                          </div>

                                          {this.state.optionsContainer ===
                                            true ? (
                                            <div className="col-md-12">
                                              <div
                                                className="d-flex align-items-center"
                                                style={{ gap: "10px" }}
                                              >
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  style={{
                                                    height: "56px",
                                                    outline: "none",
                                                    boxShadow: "none",
                                                    borderColor: "#c1c4cc",
                                                  }}
                                                  name="newName"
                                                  placeholder="Enter descriptive name for your option."
                                                  value={this.state.newName}
                                                  onChange={
                                                    this.handleInputChange
                                                  }
                                                autoComplete="new-password" />
                                                <a
                                                  className="btn btn-primary d-flex align-items-center justify-content-center"
                                                  style={{
                                                    height: "56px",
                                                    width: "5%",
                                                    padding: 0,
                                                    color: "white",
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={this.handleAddOption}
                                                >
                                                  <em
                                                    className="icon ni ni-plus-sm"
                                                    style={{ fontSize: "20px" }}
                                                  ></em>
                                                </a>
                                                <a
                                                  className="btn btn-light d-flex align-items-center justify-content-center"
                                                  style={{
                                                    height: "56px",
                                                    width: "5%",
                                                    padding: 0,
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() => {
                                                    this.setState({
                                                      optionsContainer: false,
                                                    });
                                                  }}
                                                >
                                                  Close
                                                </a>
                                              </div>
                                            </div>
                                          ) : null}
                                          <div className="col-lg-12">
                                            <h6
                                              style={{
                                                margin: 0,
                                                marginRight: "10px",
                                              }}
                                            >
                                              Description <sup>*</sup>
                                            </h6>
                                            <small>
                                              Brief description of why the
                                              appearance, testimony, or records
                                              are being sought.
                                            </small>
                                          </div>

                                          <div className="col-lg-12">
                                            <div className="form-group">
                                              <div className="form-control-group">
                                                <TextareaAutosize
                                                  maxrows={10}
                                                  name="description"
                                                  id="description"
                                                  aria-label=""
                                                  placeholder=""
                                                  //maxLength={500}
                                                  value={this.state.description}
                                                  helperText="Maximum 1000 characters"
                                                  onChange={
                                                    this.handleChangeTextarea
                                                  }
                                                  style={{
                                                    width: "100%",
                                                    minHeight: "150px",
                                                    borderColor:
                                                      "rgba(0, 0, 0, 0.125)",
                                                    borderRadius: "4px",
                                                    padding: "5px",
                                                  }}
                                                  variant="outlined"
                                                />
                                                <div className="form-note">
                                                  {remaining} characters
                                                  remaining
                                                </div>
                                              </div>
                                              {this.state.isEditorReady ? (
                                                <>
                                                  {/*<RichTextEditorComponent
                                          agreementContent={
                                            this.state.description
                                          }
                                          onContentChange={
                                            this.handleEditorChange
                                          }
                                        />*/}
                                                </>
                                              ) : null}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        className="nk-kycfm-head"
                                        title="Click to open the short description section"
                                        style={{
                                          background: "rgb(245, 246, 250)",
                                        }}
                                      >
                                        <div className="nk-kycfm-count">04</div>
                                        <div className="nk-kycfm-title">
                                          <h5 className="title">Emails</h5>
                                          <p className="sub-title">
                                            These email addresses will also
                                            receive the subpoena request email.
                                          </p>
                                        </div>
                                      </div>
                                      <div className="nk-kycfm-content">
                                        <div className="row g-4">
                                          <div
                                            className="custom-control custom-control-lg custom-checkbox col-lg-12"
                                            style={{ padding: 0, marginLeft: "3rem" }}
                                          >
                                            <div className="form-group">
                                              <input
                                                type="checkbox"
                                                className="custom-control-input"
                                                id="customCheck2"
                                                onChange={() => {
                                                  const isChecked = !this.state.notifyCheckBox;
                                                  this.setState({ notifyCheckBox: isChecked });
                                                  // console.log("Notify Checkbox Checked:", isChecked);
                                                }}
                                              />
                                              <label className="custom-control-label" for="customCheck2">
                                                Send notifications to the admin and copy the CC email addresses
                                              </label>
                                            </div>
                                          </div>
                                          <div className="col-lg-12">
                                            <div className="form-group">
                                              <label
                                                className="form-label"
                                                for="title"
                                              >
                                                CC Email(s) <sup></sup>
                                              </label>

                                              <div className="form-control-wrap">
                                                <small>
                                                  These email addresses will also receive the subpoena request if the 'Send notifications' checkbox above is selected.
                                                </small>
                                                <div style={styles.container}>
                                                  <div
                                                    style={styles.inputWrapper}
                                                  >
                                                    {this.state.emailCcs.map(
                                                      (tag, index) => (
                                                        <span
                                                          key={index}
                                                          style={styles.tag}
                                                        >
                                                          {tag}
                                                          <button
                                                            type="button"
                                                            style={
                                                              styles.removeButton
                                                            }
                                                            onClick={() =>
                                                              this.handleRemoveTagCc(
                                                                index
                                                              )
                                                            }
                                                          >
                                                            &times;
                                                          </button>
                                                        </span>
                                                      )
                                                    )}
                                                    <input
                                                      type="text"
                                                      value={inputValueCc}
                                                      onChange={
                                                        this.handleChangeTagCc
                                                      }
                                                      onKeyDown={
                                                        this.handleKeyDownCc
                                                      }
                                                      onPaste={
                                                        this.handlePasteCc
                                                      }
                                                      placeholder="Enter or paste valid email addresses..."
                                                      style={styles.input}
                                                    autoComplete="new-password" />
                                                  </div>
                                                </div>
                                                <small>
                                                  1. Only valid email addresses
                                                  are allowed.
                                                  <br />
                                                  2. Maximum 5 emails allowed.
                                                  <br />
                                                  3. No duplicates allowed (even
                                                  across pasted and existing
                                                  values).
                                                  <br />
                                                  4. Press "Enter" or "," to add
                                                  an email manually.
                                                  <br />
                                                  6. Click "X" to remove an
                                                  email.
                                                  <br />
                                                  7. Paste comma-separated
                                                  emails (with or without
                                                  spaces) (e.g.,
                                                  abc@example.com,john@example.com)
                                                </small>
                                              </div>
                                            </div>
                                            {this.state.ccErrorMessage !==
                                              "" ? (
                                              <div
                                                className="example-alert example-alert-revoke mt-3 mb-3"
                                                style={{ marginBottom: "15px" }}
                                              >
                                                <div className="alert alert-pro alert-danger">
                                                  <div className="alert-text">
                                                    <h4>CC Email Error</h4>
                                                    <p>
                                                      {
                                                        this.state
                                                          .ccErrorMessage
                                                      }
                                                    </p>
                                                  </div>
                                                </div>
                                              </div>
                                            ) : null}
                                          </div>
                                        </div>
                                      </div>

                                      <div className="nk-kycfm-footer">
                                        <div className="nk-kycfm-action pt-2 text-right">
                                          <a
                                            onClick={() =>
                                              this.addMenuHistory("/Compliance")
                                            }
                                            className="btn btn-lg btn-light"
                                            style={{
                                              marginRight: "15px",
                                              cursor: "pointer",
                                            }}
                                          >
                                            <em className="icon ni ni-step-back"></em>
                                            Back
                                          </a>
                                          <button
                                            type="submit"
                                            className="btn btn-lg btn-primary"
                                            disabled={this.state.disabled}
                                          >
                                            Submit
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </form>
                          )}
                        </div>
                      </div>
                      {/* END TABLE */}
                    </div>
                  </div>
                  {/* Table 5th Col End */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AddSubpoenaReport);
